import { Injectable, OnDestroy } from '@angular/core';
import { Network } from '@awesome-cordova-plugins/network/ngx';
import { Platform } from '@ionic/angular';
import { NetworkConnection } from './network-connection.interface';
import { Subscription, Observable, BehaviorSubject } from 'rxjs';
import { share } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NetworkConnectionService implements OnDestroy {
  private _subject = new BehaviorSubject<NetworkConnection | null>(null);
  private _disconnectSubscription!: Subscription;
  private _connectSubscription!: Subscription;

  constructor(private _network: Network, private _platform: Platform) {
    this._platform.ready().then(() => {
      this._disconnectSubscription = this._network
        .onDisconnect()
        .subscribe((network: Network) => {
          console.log('onDisconnect', network);
          this.setNetworkConnection(network);
        });
      this._connectSubscription = this._network
        .onConnect()
        .subscribe((network: Network) => {
          console.log('onConnect', network);
          this.setNetworkConnection(network);
        });
    });
  }

  getNetworkConnection(): Observable<NetworkConnection | null> {
    return this._subject.asObservable().pipe(share());
  }

  setNetworkConnection(value: any): void {
    this._subject.next(value);
  }

  clear(): void {
    this._subject.next(null);
  }

  ngOnDestroy(): void {
    this._disconnectSubscription.unsubscribe();
    this._connectSubscription.unsubscribe();
  }
}
